<template>
    <div class="hidden md:grid grid-cols-2 gap-x-4">
        <div class="flex flex-col">
            <asli-accordion-item
                v-for="(benefit, index) in evenBenefits"
                :sectionName="`whats-covered-accordion-${index}`"
                class="bg-lightGreen py-2 mb-4"
            >
                <template #header>
                    <div class="flex accordion-header font-bold text-lg px-0.5 py-2.5">
                        <asli-icon icon="tickCircleFull" class="flex-shrink-0" aria-label="tick-circle" />
                        <h3 class="accordion-title pl-4 flex-1 leading-7">{{ benefit?.title }}</h3>
                    </div>
                </template>
                <div class="bg-lightGreen accordion-content">
                    <p v-html="benefit?.description" class="pl-2"></p>
                </div>
            </asli-accordion-item>
        </div>
        <div class="flex flex-col">
            <asli-accordion-item
                v-for="(benefit, index) in oddBenefits"
                :sectionName="`whats-covered-accordion-${index}`"
                class="bg-lightGreen py-2 mb-4"
            >
                <template #header>
                    <div class="flex accordion-header font-bold text-lg px-0.5 py-2.5">
                        <asli-icon icon="tickCircleFull" class="flex-shrink-0" aria-label="tick-circle" />
                        <h3 class="accordion-title pl-4 flex-1 leading-7">{{ benefit?.title }}</h3>
                    </div>
                </template>
                <div class="bg-lightGreen accordion-content">
                    <p v-html="benefit?.description" class="pl-2"></p>
                </div>
            </asli-accordion-item>
        </div>
    </div>
    <div class="grid md:hidden grid-cols-1">
        <asli-accordion-item
            v-for="(benefit, index) in benefits"
            :sectionName="`whats-covered-accordion-${index}`"
            class="bg-lightGreen py-2 mb-4"
        >
            <template #header>
                <div class="flex accordion-header font-bold text-lg px-0.5 py-2.5">
                    <asli-icon icon="tickCircleFull" class="flex-shrink-0" aria-label="tick-circle" />
                    <h3 class="accordion-title pl-4 flex-1 leading-7">{{ benefit?.title }}</h3>
                </div>
            </template>
            <div class="bg-lightGreen accordion-content">
                <p v-html="benefit?.description" class="pl-2"></p>
            </div>
        </asli-accordion-item>
    </div>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import { BenefitDetails } from "@/stores/risk/types/types";
import { AsliAccordionItem, AsliIcon } from "@mbs-npm/anpost-ui";

const props = defineProps({
    benefits: {
        type: Array<BenefitDetails>,
        required: true
    }
});

const evenBenefits = computed(() => {
    return props.benefits.filter((_, index) => index % 2 === 0);
});

const oddBenefits = computed(() => {
    return props.benefits.filter((_, index) => index % 2 !== 0);
});
</script>
